module.exports = __webpack_public_path__ + "static/media/ml-transparent.6278f287.png";